<template>
	<el-card :style="{overflow: setOverflowClass}">
		<div v-if="isHeaderSlot || isHeaderText" slot="header">
			<slot name="header">
				<span v-if="isHeaderText">{{ headerLocalizationText }}</span>
				<div class="action-buttons">
					<!-- user defined buttons in slot -->
					<slot name="userDefinedButtons" />
				</div>
			</slot>
		</div>
		<hr style="margin: 8px 0px !important"/>
		<dms-row v-if="row">
			<slot />
		</dms-row>
		<slot v-else />
	</el-card>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'Card',
	props: {
		headerLocalizationKey: { type: String, required: false },
		headerText: { type: String, required: false },
		row: { type: Boolean, default: false },
	},
	computed: {
		isHeaderText() {
			return this.headerLocalizationKey || this.headerText;
		},
		isHeaderSlot() {
			return !!this.$slots.header;
		},
		headerLocalizationText() {
			return this.headerText
				? this.headerText
				: this.LocalizePopisostatni(this.headerLocalizationKey);
		},
		setOverflowClass() {
			return this.row ? 'visible' : 'hidden';
		},
	},
});
</script>

<style lang="scss" scoped>
	.action-buttons {
		float: right;
		margin-top: -4px;
	}
</style>
